import createGetRequestThunk from "../redux_functions/create_get_request_thunk";
import {GET_ACTIVE_USERS, GET_RETENTION} from "./marketing_type";
import {getActiveUserGraph, getRetentionTable} from "../../../../communication_system/axios_apis/axios_apis";

export const getActiveUserGraphAsync = createGetRequestThunk(GET_ACTIVE_USERS,getActiveUserGraph);
export const getRetentionTableAsync = createGetRequestThunk(GET_RETENTION,getRetentionTable)
